import VocHeaderMenuColumn from "./src/header-menu"

/* istanbul ignore next */
VocHeaderMenuColumn.install = function (Vue) {
  Vue.component(VocHeaderMenuColumn.name, VocHeaderMenuColumn)
}

export default VocHeaderMenuColumn
